module.exports = __webpack_public_path__ + "overview-a5b6df21/upload-success-f1b5655c7b4fe50457404c4a9ff24bbc.svg";